<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}故障报修</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <!-- 维修基础信息 -->
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">维修基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="维修单号" prop="no" v-if="operation == -1">
                <el-input disabled v-model="form.no" placeholder="系统自动生成维修单号" style="width: 90%"></el-input>
              </el-form-item>
              <el-form-item label="维修单号" prop="repairApplyNo" v-else>
                <el-input disabled v-model="form.repairApplyNo" placeholder="系统自动生成维修单号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="申请科室" prop="deptName">
                <el-select :disabled="!editMode" v-model="form.deptName" style="width: 90%" filterable placeholder="系统自动带出申请科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="报修人" prop="userName">
                <el-input v-model="form.userName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="申请日期" prop="date">
                <el-date-picker disabled v-model="form.date" style="width: 90%" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="系统默认为当前时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="维修科室" prop="repairDeptName">
                <el-select :disabled="!editMode" v-model="form.repairDeptName" style="width: 90%" filterable placeholder="请选择维修科室" :filter-method="getDepts" @change="repairDeptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="维修管理人" prop="repairManagerName">
                <el-select :disabled="!editMode" v-model="form.repairManagerName" style="width: 90%" filterable placeholder="请选择维修管理人" :filter-method="getUserByDetp" @change="WXuserChange">
                  <el-option v-for="item in STATIC_DeptUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="故障问题" prop="faultProblemNames">
                <SelectTree ref="ProblemTree" :multiple="true" :disabled="!editMode" @handleCheckChange="handleCheckChange" :filterable="true" :filterMethod="getFaultProblemTrees" :defaultProps="defaultProps" :placeholder="'请选择故障问题'" :data="STATIC_FaultProblemTrees" :defaultValue="form.faultProblemNames" style="width: 90%"></SelectTree>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="紧急程度" prop="urgentLevelId">
                <el-select :disabled="!editMode" v-model="form.urgentLevelId" style="width: 90%" placeholder="请选择紧急程度" @change="urgentLevelChange">
                  <el-option v-for="item in STATIC_DegreeStatus" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="期望修复日期" prop="repairDate">
                <el-date-picker :disabled="!editMode" v-model="form.repairDate" style="width: 90%" type="date" :picker-options="pickerOptions" value-format="yyyy-MM-dd" placeholder="请选择期望修复日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="故障描述" prop="desc">
                <el-input :disabled="!editMode" v-model="form.desc" placeholder="请填写故障描述" type="textarea" resize="none" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" type="textarea" resize="none" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 维修详细信息 -->
        <div class="edit-card" style="margin-top: 20px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">维修详细信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="库存范围" prop="stockRange">
                <el-select :disabled="!editMode" v-model="form.stockRange" style="width: 90%" filterable placeholder="请选择库存范围" @change="stockRangeChange">
                  <el-option v-for="item in AssetDisposaRangeOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="form.stockRange == 0">
              <el-form-item label="范围详情" prop="warehouseName">
                <el-select :disabled="!editMode" v-model="form.warehouseName" style="width: 90%" filterable placeholder="请选择范围详情" :filter-method="getWarehouses" @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-else>
              <el-form-item label="范围详情" prop="stockDeptName">
                <el-select :disabled="!editMode" v-model="form.stockDeptName" style="width: 90%" filterable placeholder="请选择范围详情" :filter-method="getDepts" @change="deptRangeChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产编号" prop="fixedAssetNo">
                <SelectTable :disabled="!editMode" :columns="stockColumns" :placeholder="'请选择资产编号'" :innerName="form.fixedAssetNo" :dataList="STATIC_Stocks" @filterMethod="getFixedAssetList" @change="selectAsset" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产名称" prop="fixedAssetName">
                <el-input disabled v-model="form.fixedAssetName" placeholder="请填写资产名称" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产卡号" prop="assetCardNoArr">
                <el-select :disabled="!editMode" v-model="form.assetCardNoArr" placeholder="请选择资产卡号" :filter-method="getAssetCards" @change="cardChange" style="width: 90%">
                  <el-option v-for="item in STATIC_AssetCards" :key="item.id" :label="item.no" :value="item.no"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input disabled v-model="form.specName" placeholder="系统自动带出规格型号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单位" prop="unitName">
                <el-input disabled v-model="form.unitName" placeholder="系统自动带出单位" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="品牌" prop="brandName">
                <el-input disabled v-model="form.brandName" placeholder="系统自动带出品牌" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="manufacturerName">
                <el-input disabled v-model="form.manufacturerName" placeholder="系统自动带出生产厂家" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商" prop="supplierName">
                <el-input disabled v-model="form.supplierName" placeholder="系统自动带出供应商" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产类型" prop="assetTypeName">
                <el-input disabled v-model="form.assetTypeName" placeholder="系统自动带出资产类型" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产地类型" prop="productionPlaceName">
                <el-input disabled v-model="form.productionPlaceName" placeholder="系统自动带出产地类型" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="财务分类" prop="financeTypeName">
                <el-input disabled v-model="form.financeTypeName" placeholder="系统自动带出财务分类" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单价" prop="price">
                <el-input-number disabled v-model="form.price" :min="0" :precision="4" :controls="false" placeholder="系统自动带出单价" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="存放地点/货位" prop="locationName">
                <el-input disabled v-model="form.locationName" placeholder="系统自动带出货位" style="width: 90%" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 维修响应信息 -->
        <div class="edit-card" style="margin-top: 20px; padding-bottom: 10px" v-if="this.operation == 0">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">维修响应信息</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item label="维修维度" prop="dimension">
                <el-select :disabled="formMode == 0" v-model="form.dimension" placeholder="请选择维修维度" style="width: 90%">
                  <el-option v-for="item in MaintenanceDimensionOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="form.dimension != 0">
              <el-form-item label="维修负责人" prop="repairUserName">
                <el-select :disabled="formMode == 0" v-model="form.repairUserName" style="width: 90%" filterable placeholder="请选择维修负责人" :filter-method="getUsers" @change="repairUserChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item v-if="form.dimension != '0'" label="维修响应说明" prop="repairDesc">
                <el-input :disabled="formMode == 0" v-model="form.repairDesc" placeholder="请填写维修响应说明" type="textarea" resize="none" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
              <el-form-item v-else label="忽略说明" prop="ignoreDesc">
                <el-input :disabled="formMode == 0" v-model="form.ignoreDesc" placeholder="请填写忽略说明" type="textarea" resize="none" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 下级接单信息 -->
        <div class="edit-card" style="margin-top: 20px; padding-bottom: 10px" v-if="operation == 1 || operation == 2 || operation == 4">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">下级接单信息</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item label="维修负责人" prop="repairUserName">
                <el-select disabled v-model="form.repairUserName" style="width: 90%" filterable placeholder="请选择维修负责人" :filter-method="getUsers" @change="receivingWXuserChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否院内维修" prop="isHospitalRepair">
                <el-select v-model="form.isHospitalRepair" style="width: 90%" filterable :disabled="formMode == 0 || operation == 4" placeholder="请选择是否院内维修">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="维修厂商名称" :prop="
                  form.isHospitalRepair == '0' ? 'repairManufacturerName' : ''
                ">
                <el-select :disabled="formMode == 0 || operation == 4" v-model="form.repairManufacturerName" style="width: 90%" filterable placeholder="请选择维修厂商名称" @change="repairManufacturerChange" :filter-method="getManufacturerGroup">
                  <el-option v-for="item in ManufacturerGroup" :key="item.type + '-' + item.id" :label="item.name" :value="item.type + '-' + item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="厂商联系人" :prop="
                  form.isHospitalRepair == '0'
                    ? 'repairManufacturerContactor'
                    : ''
                ">
                <el-input :disabled="formMode == 0 || operation == 4" v-model="form.repairManufacturerContactor" placeholder="请输入厂商联系人" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系方式" :prop="form.isHospitalRepair == '0' ? 'manufacturerPhone' : ''">
                <el-input :disabled="formMode == 0 || operation == 4" v-model="form.manufacturerPhone" placeholder="请输入联系方式" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="维修性质" prop="repairNatureId">
                <el-select :disabled="formMode == 0 || operation == 4" v-model="form.repairNatureId" style="width: 90%" filterable placeholder="请选择维修性质">
                  <el-option v-for="item in STATIC_Maintenance" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="完成维修日期" prop="date">
                <el-date-picker :disabled="formMode == 0 || operation == 4" v-model="form.date" style="width: 90%" type="date" :picker-options="{
                    disabledDate(v) {
                      return receivingDisabledDate(v);
                    },
                  }" value-format="yyyy-MM-dd" placeholder="请选择完成维修日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="维修费用" prop="repairFees">
                <el-input-number :disabled="formMode == 0 || operation == 4" v-model="form.repairFees" :min="0" :precision="4" :controls="false" placeholder="请填写维修费用" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="配件" prop="parts">
                <el-input :disabled="formMode == 0 || operation == 4" v-model="form.parts" placeholder="请填写配件" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="检修意见" prop="opinion">
                <el-input :disabled="formMode == 0 || operation == 4" v-model="form.opinion" placeholder="请填写检修意见" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 发票信息 -->
        <InvoiceEdit v-if="this.operation == 4"></InvoiceEdit>

        <!-- 院内验收信息 -->
        <div class="edit-card" style="margin-top: 20px; padding-bottom: 10px" v-if="this.operation == 4">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">院内验收信息</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item label="维修结果" prop="state">
                <el-select :disabled="formMode == 0" v-model="form.state" style="width: 90%" placeholder="请选择维修结果">
                  <el-option v-for="item in HospitalCheckOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工时（人/小时）" prop="hours">
                <el-input :disabled="formMode == 0" v-model="form.hours" placeholder="请填写维修工时" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="服务态度" prop="serviceAttitude">
                <el-select :disabled="formMode == 0" v-model="form.serviceAttitude" style="width: 90%" filterable placeholder="请选择服务态度">
                  <el-option v-for="item in ServiceAttitudeOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="技术水平" prop="abilityLevel">
                <el-select :disabled="formMode == 0" v-model="form.abilityLevel" style="width: 90%" filterable placeholder="请选择服务态度">
                  <el-option v-for="item in ServiceAttitudeOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="响应速度" prop="responseSpeed">
                <el-select :disabled="formMode == 0" v-model="form.responseSpeed" style="width: 90%" filterable placeholder="请选择响应速度">
                  <el-option v-for="item in SpeedOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="验收人" prop="checkUserName">
                <el-input disabled v-model="form.checkUserName" placeholder="系统默认为当前操作人员" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="验收时间" prop="date">
                <el-date-picker disabled v-model="form.date" style="width: 90%" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="系统默认为当前时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="验收结果" prop="checkResult">
                <el-input :disabled="formMode == 0" v-model="form.checkResult" placeholder="请填写验收结果" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="维修反馈" prop="feedback">
                <el-input :disabled="formMode == 0" v-model="form.feedback" placeholder="请填写维修反馈" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode || haveEdit" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <el-button v-else class="btn default" v-preventReClick @click="cancel">返 回</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <my-button v-if="operation != -1" class="btn primary" type="primary" v-preventReClick @click="elseSubmit">确 定</my-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  MaintenanceDimensionOptions,
  AssetDisposaRangeOptions,
  WhetherOptions,
  HospitalCheckOptions,
  ServiceAttitudeOptions,
  SpeedOptions,
} from "@/enum";
import SelectTable from "@/components/select-table";
import SelectTree from "@/components/select-tree";
import ApproveInfo from "@/components/approve-info";
import InvoiceEdit from "@/components/invoice-edit";
import {
  GetRepairApplyById,
  SaveRepairApply,
  RejectRepairApply,
  GetRepairResponseById,
  SaveRepairResponse,
  RejectRepairResponse,
  GetAcceptRepairOrderById,
  SaveAcceptRepairOrder,
  RejectAcceptRepairOrder,
  GetHospitalCheckById,
  SaveHospitalCheck,
  RejectHospitalCheck,
  GetManufacturerGroup,
  GetManufacturerInfos,
} from "@/api";
export default {
  mixins: [GetDataMixin],
  components: { SelectTable, SelectTree, ApproveInfo, InvoiceEdit },
  /** 定义属性 */
  data () {
    return {
      title: "",
      editMode: false,
      operation: -1,
      reject: RejectRepairApply,
      showWorkFlowInfo: false,
      form: {},
      rules: {},
      formRules: {
        deptName: [
          { required: true, message: "申请科室不能为空", trigger: "blur" },
        ],
        repairDeptName: [
          { required: true, message: "维修科室不能为空", trigger: "blur" },
        ],
        repairManagerName: [
          { required: true, message: "维修管理人不能为空", trigger: "blur" },
        ],
        faultProblemNames: [
          { required: true, message: "故障问题不能为空", trigger: "blur" },
        ],
        urgentLevelId: [
          { required: true, message: "紧急程度不能为空", trigger: "blur" },
        ],
        repairDate: [
          { required: true, message: "期望修复日期不能为空", trigger: "blur" },
        ],
        desc: [
          { required: true, message: "故障描述不能为空", trigger: "blur" },
        ],
        stockRange: [
          { required: true, message: "库存范围不能为空", trigger: "blur" },
        ],
        warehouseName: [
          { required: true, message: "范围详情不能为空", trigger: "blur" },
        ],
        stockDeptName: [
          { required: true, message: "范围详情不能为空", trigger: "blur" },
        ],
        fixedAssetNo: [
          { required: true, message: "资产编号不能为空", trigger: "blur" },
        ],
        assetCardNoArr: [
          { required: true, message: "资产卡号不能为空", trigger: "blur" },
        ],
      },
      MaintenanceDimensionOptions: MaintenanceDimensionOptions,
      AssetDisposaRangeOptions: AssetDisposaRangeOptions,
      defaultProps: {
        children: "children",
        label: "name",
      },
      pickerOptions: {
        disabledDate (v) {
          return v.getTime() < new Date().getTime();
        },
      },
      fixedAssetParam: {},
      ManufacturerGroup: [],

      // 接单响应
      responseForm: {},
      responseRules: {
        dimension: [
          { required: true, message: "维修维度不能为空", trigger: "blur" },
        ],
        ignoreDesc: [
          { required: true, message: "忽略说明不能为空", trigger: "blur" },
        ],
        repairUserName: [
          { required: true, message: "维修负责人不能为空", trigger: "blur" },
        ],
      },
      // 下级接单
      receivingForm: {},
      receivingRules: {
        isHospitalRepair: [
          { required: true, message: "是否院内维修不能为空", trigger: "blur" },
        ],
        repairManufacturerName: [
          { required: true, message: "维修厂商不能为空", trigger: "blur" },
        ],
        repairManufacturerContactor: [
          { required: true, message: "厂商联系人不能为空", trigger: "blur" },
        ],
        manufacturerPhone: [
          { required: true, message: "联系方式不能为空", trigger: "blur" },
        ],
        repairNatureId: [
          { required: true, message: "维修性质不能为空", trigger: "blur" },
        ],
        date: [
          { required: true, message: "完成维修日期不能为空", trigger: "blur" },
        ],
        repairFees: [
          { required: true, message: "维修费用不能为空", trigger: "blur" },
        ],
      },
      WhetherOptions: WhetherOptions,
      // 院内验收
      checkForm: {},
      checkRules: {
        state: [
          { required: true, message: "维修结果不能为空", trigger: "blur" },
        ],
      },
      HospitalCheckOptions: HospitalCheckOptions,
      ServiceAttitudeOptions: ServiceAttitudeOptions,
      SpeedOptions: SpeedOptions,
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      this.rules = this.formRules;
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      switch (this.operation) {
        case -1:
          GetRepairApplyById({ id }).then((res) => {
            this.resetForm();
            this.form = res.returnData;
            this.setFaultProblem(this.form.faultProblemIds);
            this.form.faultProblemNames = this.form.faultProblemInfos
              .map((item) => item.name)
              .join(",");
            this.initWorkFlowProperty();
            this.setAssetCard();
          });
          break;
        case 0:
          this.rules = this.responseRules;
          this.reject = RejectRepairResponse;
          GetRepairResponseById({ id }).then((res) => {
            this.resetForm();
            this.form = res.returnData;
            this.setFaultProblem(this.form.faultProblemIds);
            this.form.faultProblemNames = this.form.faultProblemInfos
              .map((item) => item.name)
              .join(",");
            this.initWorkFlowProperty();
            this.setAssetCard();
          });
          break;
        case 1:
        case 2:
          this.getRepairManufacturers();
          this.rules = this.receivingRules;
          this.reject = RejectAcceptRepairOrder;
          GetAcceptRepairOrderById({ id }).then((res) => {
            this.resetForm();
            this.form = res.returnData;
            this.setFaultProblem(this.form.faultProblemIds);
            this.form.faultProblemNames = this.form.faultProblemInfos
              .map((item) => item.name)
              .join(",");
            this.initWorkFlowProperty();
            this.setAssetCard();
            this.$set(this.form, "repairFees", undefined);
          });
          break;
        case 3:
          break;
        case 4:
          this.rules = this.checkRules;
          this.reject = RejectHospitalCheck;
          GetHospitalCheckById({ id }).then((res) => {
            this.resetForm();
            this.form = res.returnData;
            if (this.formMode != 0) {
              this.form.state = null;
            }
            this.setFaultProblem(this.form.faultProblemIds);
            this.form.faultProblemNames = this.form.faultProblemInfos
              .map((item) => item.name)
              .join(",");
            this.initWorkFlowProperty();
            this.setAssetCard();
            if (!this.form.checkUserId) {
              this.form.checkUserName = this.userInfo.userName;
              this.form.checkUserId = this.userInfo.id;
            }
          });
          break;
      }
    },
    setFaultProblem (ids) {
      this.$refs.ProblemTree.setIds(ids);
    },
    setAssetCard () {
      if (!this.form.assetCardInfos) {
        this.form.assetCardInfos = [];
      }
      this.$set(
        this.form,
        "assetCardIdArr",
        this.form.assetCardInfos?.map((e) => e.id)
      );
      this.$set(
        this.form,
        "assetCardNoArr",
        this.form.assetCardInfos?.map((e) => e.no)
      );
      this.getManufacturerGroup();
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        deptId: this.userInfo.deptId,
        deptName: this.userInfo.deptName,
        userId: this.userInfo.id,
        userName: this.userInfo.name,
        date: this.parseTime(new Date()),
        repairDeptId: "",
        repairDeptName: "",
        repairUserId: "",
        repairManagerName: "",
        faultProblemIds: "",
        faultProblemNames: "",
        urgentLevelId: "",
        degreeStatusName: "",
        desc: "",
        remark: "",
        stockRange: "",
        stockRangeName: "",
        warehouseId: "",
        warehouseName: "",
        stockDeptId: "",
        stockDeptName: "",
        fixedAssetNo: "",
        fixedAssetName: "",
        assetCardIds: "",
        assetCardIdArr: [],
        assetCardNoArr: [],
        assetCardInfos: [],
        specName: "",
        unitName: "",
        brandName: "",
        manufacturerId: "",
        manufacturerName: "",
        supplierName: "",
        assetTypeName: "",
        productionPlaceName: "",
        financeTypeName: "",
        price: "",
        locationName: "",
        hours: "",

        dimension: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveRepairApply(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    /**
     * 响应/接单/忽略/验收
     */
    elseSubmit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        switch (this.operation) {
          case 0:
            SaveRepairResponse(this.form).then((res) => {
              this.$my_message(`执行成功`, "success");
              sessionStorage.setItem("editMode", 0);
              this.$router.push({ path: this.getMainPath(this.$route.path) });
            });
            break;
          case 1:
          case 2:
            SaveAcceptRepairOrder(this.form).then((res) => {
              this.$my_message(`执行成功`, "success");
              sessionStorage.setItem("editMode", 0);
              this.$router.push({ path: this.getMainPath(this.$route.path) });
            });
            break;
          case 3:
            break;
          case 4:
            SaveHospitalCheck(this.form).then((res) => {
              this.$my_message(`执行成功`, "success");
              sessionStorage.setItem("editMode", 0);
              this.$router.push({ path: this.getMainPath(this.$route.path) });
            });
            break;
        }
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    /**
     * 获取资产编号
     */
    getFixedAssetList (keyWord) {
      var param = Object.assign(this.fixedAssetParam, {
        keyWord: keyWord,
      });
      this.GetStocksContainDetailByQuery(param);
    },
    /**
     * 获取资产卡号
     */
    getAssetCards (keyWord) {
      this.getAssetCardsByQuery({
        keyWord: keyWord,
        stockDetailId: this.form.stockDetailId,
        category: "1",
        states: [0, 1],
        deptId: this.form.stockDeptId,
        warehouseId: this.form.warehouseId,
      }).then((res) => {
        if (this.form.assetCardInfos && this.form.assetCardInfos.length > 0) {
          this.form.assetCardInfos.forEach((item) => {
            let o = this.STATIC_AssetCards.find((e) => e.id == item.id);
            if (!o) {
              this.STATIC_AssetCards.push(item);
            }
          });
        }
      });
    },
    /**
     * 供应商厂商
     */
    getManufacturerGroup (keyWord) {
      if (this.operation == 2) {
        GetRepairApplyById({ id: this.form.repairApplyId }).then((res) => {
          GetManufacturerGroup({
            keyWord: keyWord,
            cardId: this.form.assetCardIds,
            supplierId: res.returnData.supplierId,
            manufacturerId: res.returnData.manufacturerId,
          }).then((res) => {
            this.ManufacturerGroup = res.returnData.data;
          });
        });
      }
    },
    /**
     * 库存范围选择
     */
    stockRangeChange (val) {
      let item = this.AssetDisposaRangeOptions.find((e) => e.id == val);
      if (item) {
        this.form.stockRangeName = item.name;
      }
      this.form.warehouseId = null;
      this.form.warehouseName = null;
      this.form.stockDeptName = null;
      this.form.stockDeptId = null;
      this.warehouseChange();
    },
    /**
     * 范围详情库房选择
     */
    warehouseChange (val) {
      this.form.warehouseId = val;
      if (this.form.stockRange == 0) {
        this.fixedAssetParam = {
          warehouseId: this.form.warehouseId,
        };
      }
      this.restAsset();
      this.getFixedAssetList();
    },
    /**
     * 范围详情科室选择
     */
    deptRangeChange (val) {
      this.form.stockDeptId = val;
      if (this.form.stockRange == 1) {
        this.fixedAssetParam = {
          deptId: this.form.stockDeptId,
        };
      }
      this.restAsset();
      this.getFixedAssetList();
    },
    /**
     * 维修科室选择
     */
    repairDeptChange (val) {
      this.form.repairDeptId = val;
      this.getUserByDetp();
    },
    /**
     * 维修负责人选择
     */
    WXuserChange (val) {
      this.form.repairManagerId = val;
    },
    /**
     * 重置资产编号及附带信息
     */
    restAsset () {
      this.$set(this.form, "fixedAssetNo", null);
      this.$set(this.form, "fixedAssetName", null);
      this.$set(this.form, "assetCardNoArr", []);
      this.$set(this.form, "assetCardIds", null);
      this.$set(this.form, "assetCardIdArr", []);
      this.$set(this.form, "assetCardInfos", []);
      this.$set(this.form, "specName", null);
      this.$set(this.form, "unitName", null);
      this.$set(this.form, "brandName", null);
      this.$set(this.form, "manufacturerName", null);
      this.$set(this.form, "supplierName", null);
      this.$set(this.form, "assetTypeName", null);
      this.$set(this.form, "productionPlaceName", null);
      this.$set(this.form, "financeTypeName", null);
      this.$set(this.form, "price", undefined);
      this.$set(this.form, "locationName", null);
    },
    /**
     * 资产编号选择
     */
    selectAsset (row) {
      this.form = Object.assign(this.form, row, {
        // fixedAssetNo: row.no,
        // fixedAssetName: row.name,
        location: row.locationName,
        stockDetailId: row.stockDetailId,
        deptId: this.form.deptId,
        deptName: this.form.deptName,
        assetId: row.assetId,
        deptId: this.form.deptId,
        deptName: this.form.deptName,
        warehouseId: this.form.warehouseId,
        warehouseName: this.form.warehouseName,
        number: 1,
        id: this.form.id,
        stockState: row.state,
        unBillNumber: 1,
        unBillAmount: row.price,
      });
      this.form.assetCardNoArr = [];
      this.getAssetCards("");
    },
    /**
     * 资产卡号选择
     */
    cardChange (val) {
      if (val && val.length > 0) {
        let obj = this.STATIC_AssetCards.find((e) => e.no == val);
        if (obj) {
          this.form.assetCardInfos = [obj];
        }
        this.form.assetCardIds = this.form.assetCardInfos
          .map((item) => item.id)
          .join(";");
      } else {
        this.form.assetCardIds = "";
        this.form.assetCardInfos = [];
      }
      this.getManufacturerGroup();
    },
    /**
     * 故障问题选择
     */
    handleCheckChange (node) {
      if (node) {
        this.form.faultProblemIds = node.map((item) => item.id).join(";");
        this.form.faultProblemNames = node.map((item) => item.name).join(",");
      } else {
        this.form.faultProblemIds = "";
        this.form.faultProblemNames = "";
      }
    },
    /**
     * 紧急程度选择
     */
    urgentLevelChange (val) {
      let item = this.STATIC_DegreeStatus.find((e) => e.id == val);
      if (item) {
        this.form.urgentLevelName = item.name;
      }
    },
    /**
     * 科室选择
     */
    deptChange (val) {
      this.form.deptId = val;
    },
    /**
     * 维修负责人选择
     */
    repairUserChange (val) {
      this.form.repairUserId = val;
    },
    // 接单事件
    restResponseForm () {
      this.receivingForm = {
        repairUserId: "",
        repairUserName: "",
        isHospitalRepair: 1,
        repairManufacturerName: "",
        repairManufacturerContactor: "",
        manufacturerPhone: "",
        repairNatureId: "",
        date: "",
        repairFees: "",
        parts: "",
        opinion: "",
      };
    },
    // 维修负责人选择
    receivingWXuserChange (val) {
      this.receivingForm.repairUserId = val;
    },
    receivingDisabledDate (v) {
      if (this.form.date) {
        return v.getTime() < new Date(this.form.date).getTime();
      } else {
        return false;
      }
    },
    /**
     * 维修厂商选择
     */
    repairManufacturerChange (val) {
      this.form.type = val.split("-")[0];
      this.form.repairManufacturerId = val.split("-")[1];
      let item = this.ManufacturerGroup.find(
        (e) => e.id == this.form.repairManufacturerId
      );
      if (item) {
        this.$set(
          this.form,
          "repairManufacturerContactor",
          item.repairManufacturerContactor
        );
        this.$set(this.form, "manufacturerPhone", item.repairManufacturerPhone);
        this.$set(this.form, "type", item.type);
      }
    },
    getUserByDetp (val) {
      this.getDeptUsers(this.form.repairDeptId, val);
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.getFixedAssetList("");
    this.InitData();
    var query = this.$route.query;
    if (query.operation) {
      this.operation = query.operation * 1;
    }
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    this.getUsers("");
    this.getDepts("");
    this.getDeptUsers("");
    this.getWarehouses();
    this.getAssetCards();
    this.getFaultProblemTrees();
    this.getDegreeStatus();
    this.getMaintenance();

    this.restResponseForm();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () { },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
